import { useState } from 'react';

// Simple blurred placeholder (base64 tiny gray image)
export const BLUR_PLACEHOLDER =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBmaWxsPSIjZGRkZGRkIi8+PC9zdmc+';

// Custom hook to handle image loading with placeholder
export function useImageWithPlaceholder(src) {
  const [loaded, setLoaded] = useState(false);
  return {
    src: loaded ? src : BLUR_PLACEHOLDER,
    onLoad: () => setLoaded(true),
    style: loaded ? {} : { filter: 'blur(8px)', background: '#eee' },
  };
}

// BlurredImage component for easy use
export function BlurredImage({ src, alt, style, fallbackUrl, ...rest }) {
  const [error, setError] = useState(false);
  const imgProps = useImageWithPlaceholder(!error ? src : fallbackUrl || src);
  return (
    <img
      {...rest}
      src={imgProps.src}
      alt={alt}
      style={{ ...style, ...imgProps.style }}
      onLoad={imgProps.onLoad}
      onError={() => setError(true)}
      loading="lazy"
    />
  );
}
